
<div class="row" *ngIf="token">
  <div class="col common-padding show-code">
    <div class="row align-items-center">
      <div class="col-md-6">
        <h2 class="heading">Show Code</h2>
      </div>

      <div class="col-md-6 text-right">
        <div class="share_detail">
          <!--<i class="icon-share mr-3"></i>-->
          <button class="btn btn-primary" style="float: right;" (click)="Back()">Back</button>

          <!--<span class="" (click)="openModal()">Share Your EziPay Detail</span>-->
        </div>
      </div>
    </div>

    <div class="row align-items-center">
      <div class="col-md-6 text-center qr-code">
        <h6>
          To Pay {{fullusername}}
        </h6>
        <p>Share your EziPay QR Code to receive payments</p>
        <img [src]="codeUrl" class="img-fluid" />

      </div>

      <div class="col-md-6">
        <div class="pay-detail text-center">
          <div class="or">
            <p>OR</p>
          </div>
          <div class="icon_wrap">
            <img src="assets/Images/show-code.png" class="img-fluid" />
          </div>
          <span class="ng-binding">Enter Mobile Number To Pay</span>
          <p>{{currentUser.MobileNo}}</p>
        </div>
      </div>
    </div>
  </div>
</div>








